import { CalendarCheck, Scissors, BadgeCheck } from "lucide-react";
import { Eyebrow, Heading } from "./Section";

const FEATURES = [
  { icon: CalendarCheck, title: "Easy Online Booking", desc: "Book in under a minute through Square — no calls needed." },
  { icon: Scissors, title: "7+ Years Experience", desc: "Cutting in Pakenham since 2019." },
  { icon: BadgeCheck, title: "Consistent Quality", desc: "Same sharp standard, every single visit." },
];

export const WhyBook = () => (
  <section data-testid="why-book" className="py-20 md:py-28 bg-charcoal">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="mb-12">
        <Eyebrow>Why AK Cuts</Eyebrow>
        <Heading>NO SHORTCUTS, EVER</Heading>
      </div>

      <div className="grid md:grid-cols-3 gap-5">
        {FEATURES.map((f) => (
          <div key={f.title} data-testid={`feature-${f.title}`}
            className="bg-black/40 border border-white/10 rounded-xl p-7 hover:border-barber-red/60 transition-colors">
            <div className="w-12 h-12 rounded-lg bg-barber-red/15 flex items-center justify-center mb-5">
              <f.icon className="text-barber-red" size={24} />
            </div>
            <h3 className="font-display text-2xl tracking-wide text-cream">{f.title}</h3>
            <p className="mt-2 text-sm text-cream/60 font-body leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
